import { useCallback } from "react"
import { useT } from "react-polyglot-hooks"
import DefaultLayout from "components/layouts/DefaultLayout"
import Typography from "components/styled/Typography"
import { Container } from "components/styled/Grid"
import * as PropTypes from "prop-types"
import Canonical from "components/Canonical"
import { NextSeo } from "next-seo"
import styled from "styled-components"

const CookiePreferencesButton = styled.button`
  margin-top: 32px;
  padding: 10px 20px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.deepPink};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.deepPink};
  font-weight: ${({ theme }) => theme.weights.medium};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.deepPink};
    color: ${({ theme }) => theme.colors.white};
  }
`

export default function LegalScene({ page, markdown }) {
  const t = useT()
  const openCookiePreferences = useCallback(() => {
    if (typeof window === "undefined" || !window.Cookiebot) return
    if (typeof window.Cookiebot.renew === "function") {
      window.Cookiebot.renew()
      return
    }
    if (typeof window.Cookiebot.show === "function") {
      window.Cookiebot.show()
    }
  }, [])

  return (
    <DefaultLayout page={page}>
      <Canonical page={page} />
      <NextSeo title={t(`common.legal.${page}`)} noindex />
      <Container top={50} bottom={150}>
        <Typography variant="title2" weight="bold" center space style={{ marginBottom: "50px" }}>
          {t(`common.legal.${page}`)}
        </Typography>
        <div dangerouslySetInnerHTML={{ __html: markdown }} />
        {page === "cookies" && (
          <CookiePreferencesButton type="button" onClick={openCookiePreferences}>
            {t("common.legal.configure_cookies")}
          </CookiePreferencesButton>
        )}
      </Container>
    </DefaultLayout>
  )
}

LegalScene.propTypes = {
  markdown: PropTypes.string.isRequired,
  page: PropTypes.oneOf(["privacy", "terms", "cookies", "fca_terms", "legal"]).isRequired
}
